import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Sidebar from "../../Components/Sidebar";
import { useDispatch } from "react-redux";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { addCQAData } from "../../redux/actions/CQAAction";
import PageComponent from "../../Components/PageComponent";

function AddCQA() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const dispatch = useDispatch();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!title || !description || !file) {
      alert("Please fill in all required fields and upload an image.");
      return;
    }

    setIsSaving(true);

    // Create FormData object
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("file", file);

    try {
      // Dispatch addNews action
      await dispatch(
        addCQAData(formData, () => {
          alert("CQA added successfully done!");
          // Reset form fields
          setTitle("");
          setDescription("");
          setFile(null);
  
          // Navigate to another page
          navigate("/gallery&News/get-cqa");
        })
      );
      setTitle("");
          setDescription("");
          setFile(null);
      
    } catch (error) {
      console.error("Failed to save news:", error);
      alert(`Error adding news: ${error.response?.data?.message || "Unknown error"}`);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>

      <div className="flex-1 p-6 ml-64">
        <div className="mb-6">
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Gallery & News</span>
          <span>/</span>
          <span className="text-black">Center for Quality Assurance (CQA)</span>
        </div>
        <div className="flex items-center mt-4 space-x-4">
            <button
              className="px-4 py-2 text-[#92288C] border border-[#92288C] rounded-md shadow hover:bg-gray-100"
              onClick={() => navigate("/gallery&News/cqa-description")}
            >
              Add Description
            </button>
            <button
              className="px-4 py-2 text-white bg-[#92288C] rounded-md shadow hover:bg-[#6C0B67]"
              onClick={() => navigate("/gallery&News/add-cqa")}
            >
              Add New Resource
            </button>
            <button className="px-4 py-2 text-[#92288C] border border-[#92288C] rounded-md shadow hover:bg-gray-100"
            onClick={() => navigate("/gallery&News/get-cqa")}
            >
              Resource List
            </button>
            <button
              className="px-4 py-2 text-[#92288C] border border-[#92288C] rounded-md shadow hover:bg-gray-100"
              onClick={() => navigate("/gallery&News/cqa-staff")}
            >
              CQA Staff
            </button>
          </div>
        </div>

        <div className="p-6 bg-white rounded-lg shadow-md">
          <h2 className="mb-4 text-xl font-bold">Add News one</h2>
          <form onSubmit={handleSave}>
            <div className="space-y-6">
              {/* Title and Publish Date */}
              <div className="flex space-x-4">
                <div className="flex-1">
                  <label className="block text-gray-700">Title</label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                    placeholder="Enter title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
               
              </div>

              {/* Description */}
              <div>
                <label className="block mb-1 text-gray-700">Description</label>
                <ReactQuill
                  value={description}
                  onChange={setDescription}
                 
                  placeholder="Enter description"
                  className="h-[150px] mb-14"
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      [{ font: [] }],
                      ["bold", "italic", "underline"],
                      [{ align: [] }],
                      ["clean"],
                    ],
                  }}
                  formats={[
                    "font",
                    "header",
                    "bold",
                    "italic",
                    "underline",
                    "align",
                  ]}
                  theme="snow"
                />
              </div>

        
    
              <label className="block text-gray-700">Upload Document</label>
              {/* File Upload */}
              <div className="flex items-center space-x-4">

                <input
                  type="text"
                  readOnly
                  value={file ? file.name : ""}
                  placeholder="No file selected"
                  className="flex-1 px-4 py-2 bg-gray-100 border border-gray-300 rounded-md cursor-not-allowed focus:outline-none"
                />
                <label
                  htmlFor="file-upload"
                  className="px-4 py-2 text-white bg-[#92288C] rounded-md shadow cursor-pointer hover:bg-[#6C0B67]"
                >
                  Browse File
                </label>
                <input
                  type="file"
                  id="file-upload"
                  onChange={handleFileChange}
                  className="hidden"
                />
              </div>
            
             
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end mt-6 space-x-4">
              <button
                type="button"
                onClick={() => navigate("/gallery&News/cqa-description")}
                className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSaving}
                className={`px-4 py-2 text-white rounded-md ${
                  isSaving
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#92288C] hover:bg-[#6C0B67]"
                }`}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </PageComponent></>
  );
}

export default AddCQA;
